/* istanbul ignore file */
import React from 'react'
import PropTypes from 'prop-types'
import _cx from 'classnames/bind'
import { CostView } from '../../../../modules/bidBanner/costCalculations/index'
import cls from './styles.scss'

const cx = _cx.bind(cls)

const YOUR_PREVIOUS_BID_LABEL = 'Your Previous Bid'
const MATCH_BID_LABEL = 'Match Bid'
const BUYERS_PREMIUM_LABEL = "Buyer's Premium"
const TOTAL_PURCHASE_PRICE_LABEL = 'Total Purchase Price'
const EARNEST_MONEY_DEPOSIT = 'Earnest Money Deposit'

const YourPreviousBid = props => {
  return (
    <CostView
      elmId='cost_calculation_your_bid'
      label={YOUR_PREVIOUS_BID_LABEL}
      {...props}
    />
  )
}
const MatchBid = props => {
  return (
    <CostView
      elmId='cost_calculation_your_bid'
      label={MATCH_BID_LABEL}
      {...props}
    />
  )
}

const BuyersPremium = props => {
  return (
    <CostView
      elmId='cost_calculation_buyers_premium'
      label={BUYERS_PREMIUM_LABEL}
      {...props}
    />
  )
}

const TotalPurchasePrice = props => {
  return (
    <CostView
      elmId='cost_calculation_total_purchase_price'
      label={TOTAL_PURCHASE_PRICE_LABEL}
      {...props}
    />
  )
}

const EarnestMoneyDeposit = props => {
  return (
    <CostView
      elmId='cost_calculation_earnest_money_deposit'
      label={EARNEST_MONEY_DEPOSIT}
      {...props}
    />
  )
}

const Costs = ({ currentBidAmount, currentUserBidAmount, calculations }) => {
  return (
    <div
      data-elm-id='confirm_bid_calculations'
      className={cx('contains-emphasis', 'margin-bottom')}
    >
      <div className={cx('margin-bottom')}>
        <YourPreviousBid value={currentUserBidAmount} />
      </div>
      <div className={cx('border-top', 'border-bottom', 'margin-bottom')}>
        <MatchBid value={currentBidAmount} />
        <BuyersPremium operator='+' value={calculations.buyersPremium} />
        <TotalPurchasePrice
          labelWeight='heavy'
          operator='='
          value={calculations.totalPurchasePrice}
          valueBackground='grayExtraLight'
          valueWeight='heavy'
        />
      </div>
      <EarnestMoneyDeposit
        labelColor='grayMedium'
        value={calculations.earnestMoneyDeposit}
        valueColor='grayMedium'
      />
    </div>
  )
}

Costs.propTypes = {
  currentBidAmount: PropTypes.number,
  currentUserBidAmount: PropTypes.number,
  calculations: PropTypes.object,
}
export default Costs
